import Marquee from "react-fast-marquee";
import { useLang } from "../i18n/LanguageContext";

const phrasesEn = [
  "Eliminate Odour",
  "Accelerate Decomposition",
  "Reduce Methane",
  "Restore Biological Activity",
  "Improve Bio-mining Efficiency",
  "Support Swachh Bharat & ESG",
];

const phrasesHi = [
  "गंध समाप्त करें",
  "अपघटन तेज़ करें",
  "मीथेन घटाएँ",
  "जैविक सक्रियता बहाल करें",
  "बायो-माइनिंग दक्षता बढ़ाएँ",
  "स्वच्छ भारत व ESG का समर्थन",
];

export const Ticker = () => {
  const { lang } = useLang();
  const phrases = lang === "hi" ? phrasesHi : phrasesEn;
  return (
    <div data-testid="editorial-marquee" className="bg-sand border-y border-stone/20 py-6 md:py-8">
      <Marquee speed={38} gradient={false} autoFill>
        {phrases.map((p, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-3xl md:text-5xl text-moss px-10 md:px-16">
              {p}
            </span>
            <span className="text-terracotta text-2xl md:text-3xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
